import React, { useState } from 'react';
import Layout from './components/Layout';
import CourseCard from './components/CourseCard';
import CategoryFilter from './components/CategoryFilter';
import { featuredCourses, gridCourses, categories } from './data/courses';
import logoXB from './images/logoXB.png';
import './Todos.css';

function Todos() {
  const [activeCategory, setActiveCategory] = useState('Todos');

  const filteredCourses = activeCategory === 'Todos'
    ? gridCourses
    : gridCourses.filter(c => c.category === activeCategory);

  return (
    <Layout title="Todos os Cursos" favicon="/todos.ico">
      {/* Hero Section */}
      <section className="landing-hero">
        <div className="container">
          <img src={logoXB} alt="Xadrez Brasil" className="landing-hero__logo" />
          <h2 className="landing-hero__title">Melhore no Xadrez com os cursos de</h2>
          <h1 className="landing-hero__subtitle">Aberturas, Cálculo, Estratégia e Finais</h1>
        </div>
      </section>

      {/* Featured Courses */}
      <section className="landing-featured">
        <div className="container">
          {featuredCourses.map(course => (
            <CourseCard key={course.id} course={course} featured />
          ))}
        </div>
      </section>

      {/* Course Grid */}
      <section className="landing-section">
        <div className="container">
          <h2 className="landing-section__title">Cursos Individuais</h2>
          <CategoryFilter
            categories={categories}
            activeCategory={activeCategory}
            onCategoryChange={setActiveCategory}
          />
          <div className="course-grid">
            {filteredCourses.map(course => (
              <CourseCard key={course.id} course={course} />
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default Todos;
